export function obscureEmail(email) {
  const [localPart, domain] = email.split('@');
  return `${localPart.substring(0, 3)}${'*'.repeat(
    localPart.length - 3
  )}@${domain}`;
}
